module.exports = __webpack_public_path__ + "42a82644b21595889d2feb88661b18b7.MP3";